import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { BackgroundImage } from "../../../assets/img/widgets/staticWilmaBanner";
import { getActiveWorkspace } from "../../../helpers/selectors";
import { defaultSettings } from "./helper";

const MessageLink = ({ to, children }) => {
  if (!to) {
    return (<>{children}</>);
  }

  return (
    <a
      href={to}
      style={{
        color: "inherit",
        textTransform: "none",
        textDecoration: "none",
      }}
      target={URL.canParse(to) ? "_blank" : ""}
    >
      {children}{(to?.length > 0) && (<>&nbsp;»</>)}
    </a>
  );
};

const BannerWidgetComponent = ({ layout, sx }) => {
  const { name: workspaceName } = useSelector(getActiveWorkspace);
  const { companyName } = useSelector(state => state.api.currentViewer.viewer);

  const { settings } = layout || {};

  const baseTypography = {
    fontFamily: "lato",
    lineHeight: 1.3,
    opacity: 0.94,
    textShadow: "2.57px 3.06px 10px rgba(0, 0, 0, 0.3)",
  };

  const getSetting = (name) => (settings?.[name] || defaultSettings[name]);

  return (
    <Box
      sx={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "6px",
        display: "flex",
        fontFamily: "lato",
        height: "100%",
        overflow: "hidden",
        padding: "1em 2em",
        position: "absolute",
        width: "100%",
        ...sx
      }}
    >
      <Box sx={{
        margin: "auto 0px",
        paddingLeft: "1em",
        "&::after": {
          content: '""',
          position: "absolute",
          top: "1em",
          bottom: "1em",
          left: "2em",
          width: "2px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          boxShadow: baseTypography.textShadow,
        },
      }}>
        <Typography variant="h4" sx={{ ...baseTypography, color: getSetting("headingColor"), fontWeight: 600, lineHeight: 1 }}>
          {getSetting("headingText") || workspaceName || companyName}
        </Typography>
        <Typography sx={{ ...baseTypography, color: getSetting("messageColor"), fontSize: "15px", whiteSpace: "pre-wrap" }}>
          {getSetting("messageText")}
        </Typography>
      </Box>
      <Box sx={{ margin: "auto 0px 0px auto" }}>
        <Typography sx={{ ...baseTypography, color: getSetting("linkColor"), opacity: 0.9 }}>
          <MessageLink to={getSetting("linkUrl")}>
            {getSetting("linkText")}
          </MessageLink>
        </Typography>
      </Box>
    </Box>
  );
};

export default BannerWidgetComponent;
